import { get } from "@insite/client-framework/Services/ApiService";

export interface CatFaqModel {
   id: string;
    question: string;
    answer: string;
}

export interface CatFaqCollectionModel {
    uri: string;
    brandId: string;
    faqs: CatFaqModel[];
    properties: Record<string, unknown>;
}


export interface GetCatFaqsApiParameter {
    categoryId: string;
}

export function getCatFaqs(apiParameter: GetCatFaqsApiParameter) {
    return get<CatFaqCollectionModel>(`/api/v2/faq/category/${apiParameter.categoryId}`);
}


 